import React, { useState, useEffect } from 'react';
import { 
    Container, Row, Col, Card, CardHeader, CardBody, 
    Input, Spinner 
} from 'reactstrap';
import { APIClient } from '../../helpers/api_helper';
import { toast, ToastContainer } from 'react-toastify';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import 'react-toastify/dist/ReactToastify.css';

const Gender = () => {
    document.title = "Gender Types";
    
    const [genders, setGenders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchGenders = async () => {
        try {
            setLoading(true);
            const response = await APIClient.get('/gender');
            if (response?.data?.data) {
                setGenders(response.data.data);
            }
            else{
                toast.error('Failed to fetch genders', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored"
                });
            }
        } catch (error) {
            toast.error(error.message || 'Failed to fetch genders', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored"
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGenders();
    }, []);

    // Filter genders based on search term
    const filteredGenders = genders.filter(gender => 
        gender.genderTitle.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="page-content">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <Container fluid>
                <BreadCrumb title="Gender Types" pageTitle="App Settings" />
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="d-flex align-items-center">
                                <h4 className="card-title mb-0 flex-grow-1">Gender Types</h4>
                                <div className="d-flex gap-2">
                                    <div className="search-box">
                                                <Input 
                                            type="text"
                                            className="form-control search"
                                            placeholder="Search gender..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        <i className="ri-search-line search-icon"></i>
                                            </div>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {loading ? (
                                    <div className="text-center p-4">
                                        <Spinner color="primary"> Loading... </Spinner>
                                    </div>
                                ) : (
                                    <div className="gender-grid">
                                        {filteredGenders.length > 0 ? (
                                            filteredGenders.map((gender, index) => (
                                                <div key={index} className="gender-item">
                                                        <div className="d-flex align-items-center">
                                                        <i className="ri-user-5-line me-2 text-muted"></i>
                                                        <span>{gender.genderTitle}</span>
                                                            </div>
                                                        </div>
                                            ))
                                        ) : (
                                            <div className="text-center text-muted py-4">
                                                <h5 className="mb-1">No genders found</h5>
                                                {searchTerm && <p className="mb-0">Try adjusting your search</p>}
                                                            </div>
                                        )}
                                                            </div>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <style>
                {`
                .search-box {
                    position: relative;
                    width: 250px;
                }

                .search-box .search-icon {
                    position: absolute;
                    right: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #878a99;
                    z-index: 1;
                    pointer-events: none;
                }

                .search-box .form-control {
                    padding-right: 35px;
                    border-radius: 6px;
                }

                .search-box .form-control:focus {
                    border-color: #405189;
                    box-shadow: none;
                }

                .gender-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
                    gap: 1rem;
                    padding: 1rem;
                }

                .gender-item {
                    background-color: #f8f9fa;
                    border: 1px solid #e9ebec;
                    border-radius: 8px;
                    padding: 12px 16px;
                    transition: all 0.3s ease;
                }

                .gender-item:hover {
                    background-color: #fff;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                    transform: translateY(-2px);
                }
                `}
            </style>
        </div>
    );
};

export default Gender;